import { readSetupUnits } from '../lib/firstRun'
import { unitsForLocale } from '../lib/units'
import { parseSettings } from './settings'
import { useSynced } from './useSync'

/**
 * The SETTINGS groups, with the profile's display units. Before a profile is saved: the units picked in setup, else the
 * ones the browser's region usually uses.
 */
export function useSettings() {
  const query = useSynced('SETTINGS', parseSettings)
  const profile = query.data?.profile ?? null
  return { query, settings: query.data, profile, units: profile?.units ?? readSetupUnits() ?? unitsForLocale(navigator.language) }
}
